import { combineReducers } from '@reduxjs/toolkit';

import authReducer from 'state/reducers/auth';
import featureFlagsReducer from 'state/reducers/featureFlags';
import reportsReducer from 'state/reducers/reports';
import locationsReducer from './locations';
import merchantsReducer from './merchants';
import merchantNetworksReducer from './merchantNetworks';
import offersReducer from './offers';
import usersReducer from './users';
import pendingTransactionsReducer from './pendingTransactions';
import auditsReducer from './audits';
import exportDataReducer from './exportData';
import layoutReducer from './layout';

const combinedReducer = combineReducers({
  auth: authReducer,
  featureFlags: featureFlagsReducer,
  reports: reportsReducer,
  users: usersReducer,
  offers: offersReducer,
  merchants: merchantsReducer,
  merchantNetworks: merchantNetworksReducer,
  locations: locationsReducer,
  pendingTransactions: pendingTransactionsReducer,
  audits: auditsReducer,
  exportData: exportDataReducer,
  layout: layoutReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === '[Auth] Logout Success') {
    return combinedReducer(undefined, action);
  }

  return combinedReducer(state, action);
};

export default rootReducer;
